import React, { useState } from "react";
import "./StepCompetences.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

export default function StepCompetences({
    formData,
    setFormData,
    onNext,
    onPrev,
    secteur,
    listSecteurs
}) {
    const [selectedSecteur, setSelectedSecteur] = useState(secteur || null);
    const [competence, setCompetence] = useState(null);
    const [competences, setCompetences] = useState(formData.competences || []);

    const handleAddCompetence = () => {
        if (!competence) return;

        if (competences.some((c) => c.idMetier === competence.idMetier)) {
            alert("Cette compétence est déjà ajoutée.");
            return;
        }

        const newCompetences = [...competences, competence];
        setCompetences(newCompetences);
        setFormData({ ...formData, competences: newCompetences });
        setCompetence(null);
    };

    const removeCompetence = (index) => {
        const newCompetences = competences.filter((_, i) => i !== index);
        setCompetences(newCompetences);
        setFormData({ ...formData, competences: newCompetences });
    };

    return (
        <>
            <h2 className="step-title">Ajouter des compétences</h2>

            {/* Secteur principal affiché */}
            <div className="secteur-principal">
                <strong>Secteur principal :</strong> {secteur?.labelSecteur}
            </div>

            {/* Sélecteur de secteur pour ajouter des compétences */}
            <div className="competence-form">
                <label htmlFor="secteurSelect">Choisir un secteur :</label>
                <select
                    id="secteurSelect"
                    value={selectedSecteur?.idSecteur || ""}
                    onChange={(e) => {
                        const selected = listSecteurs.find(
                            (s) => s.idSecteur === parseInt(e.target.value, 10)
                        );
                        setSelectedSecteur(selected || null);
                        setCompetence(null);
                    }}
                >
                    <option value="">-- Sélectionnez un secteur --</option>
                    {listSecteurs.map((s) => (
                        <option key={s.idSecteur} value={s.idSecteur}>
                            {s.labelSecteur}
                        </option>
                    ))}
                </select>
            </div>

            {/* Sélecteur de compétence (métier) */}
            {selectedSecteur && (
                <div className="competence-form">
                    <label htmlFor="competenceSelect">Compétence :</label>
                    <select
                        id="competenceSelect"
                        value={competence?.idMetier || ""}
                        onChange={(e) => {
                            const metier = selectedSecteur.metiers.find(
                                (m) => m.idMetier === parseInt(e.target.value, 10)
                            );
                            if (metier) {
                                const metierWithSecteur = { ...metier, secteur: selectedSecteur };
                                setCompetence(metierWithSecteur);
                            } else {
                                setCompetence(null);
                            }
                        }}
                    >
                        <option value="">-- Sélectionnez un métier --</option>
                        {selectedSecteur.metiers?.map((metier) => (
                            <option key={metier.idMetier} value={metier.idMetier}>
                                {metier.labelMetier}
                            </option>
                        ))}
                    </select>
                    <button type="button" onClick={handleAddCompetence} disabled={!competence}>
                        Ajouter
                    </button>
                </div>
            )}

            {/* Liste des compétences ajoutées */}
            {competences.length > 0 && (
                <div className="competences-list">
                    <h3>Compétences ajoutées</h3>
                    {competences.map((comp, index) => (
                        <div key={index} className="competence-item">
                            <span>
                                {comp.labelMetier}
                                <small className="competence-secteur">
                                    {" "}
                                    ({comp?.secteur?.labelSecteur || "Secteur inconnu"})
                                </small>
                            </span>
                            <button
                                type="button"
                                onClick={() => removeCompetence(index)}
                                title="Supprimer"
                            >
                                <FontAwesomeIcon icon={faTrash} />
                            </button>
                        </div>
                    ))}
                </div>
            )}

            <div className="inscriptionClientModal-actions">
                <button type="button" onClick={onPrev}>Précédent</button>
                <button
                    type="button"
                    disabled={competences.length === 0}
                    onClick={onNext}
                >
                    Suivant
                </button>
            </div>
        </>
    );
}
